import React, { useState } from "react";

const QA = () => {
  const [filters, setFilters] = useState({
    ccNo: "",
    phone: "",
    date: "",
    callAssessor: ""
  });

  const [data] = useState([
    {
      customerID: "CUST001",
      assignedQAUser: "QA_User1",
      finalDisposition: "Approved",
      leadsourceName: "Facebook",
      campaignName: "SummerCampaign",
      firstName: "John",
      lastName: "Doe",
      address: "123 Main St",
      city: "New York",
      state: "NY",
      postcode: "10001",
      disposition: "Interested",
      totalProduct: "3",
      saleDate: "2025-08-15",
      centerName: "Center A"
    },
    {
      customerID: "CUST002",
      assignedQAUser: "QA_User2",
      finalDisposition: "Rejected",
      leadsourceName: "Google Ads",
      campaignName: "WinterPromo",
      firstName: "Jane",
      lastName: "Smith",
      address: "456 Oak Ave",
      city: "Chicago",
      state: "IL",
      postcode: "60601",
      disposition: "Not Interested",
      totalProduct: "1",
      saleDate: "2025-08-18",
      centerName: "Center B"
    }
  ]);

  // filter logic (basic)
  const filteredData = data.filter((item) => {
    const matchesCC = filters.ccNo
      ? item.customerID.includes(filters.ccNo)
      : true;
    const matchesPhone = filters.phone
      ? item.customerID.includes(filters.phone) || item.phone?.includes(filters.phone)
      : true;
    const matchesDate = filters.date ? item.saleDate === filters.date : true;
    const matchesAssessor = filters.callAssessor
      ? item.assignedQAUser === filters.callAssessor
      : true;

    return matchesCC && matchesPhone && matchesDate && matchesAssessor;
  });

  return (
    <div className="page">
      <h2>QA Report</h2>

      {/* Filter Bar */}
      <div className="filter-container">
        <input
          type="text"
          placeholder="CC No."
          value={filters.ccNo}
          onChange={(e) => setFilters({ ...filters, ccNo: e.target.value })}
        />
        <input
          type="text"
          placeholder="Phone No."
          value={filters.phone}
          onChange={(e) => setFilters({ ...filters, phone: e.target.value })}
        />
        <input
          type="date"
          value={filters.date}
          onChange={(e) => setFilters({ ...filters, date: e.target.value })}
        />
        <select
          value={filters.callAssessor}
          onChange={(e) =>
            setFilters({ ...filters, callAssessor: e.target.value })
          }
        >
          <option value="">Select Call Assessor</option>
          <option value="QA_User1">QA_User1</option>
          <option value="QA_User2">QA_User2</option>
          <option value="QA_User3">QA_User3</option>
        </select>
        <button className="search-btn">Search</button>
      </div>

      {/* Table Section */}
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>CustomerID</th>
              <th>Assigned QA User</th>
              <th>Final Disposition</th>
              <th>Leadsource Name</th>
              <th>Campaign Name</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Address</th>
              <th>City</th>
              <th>State</th>
              <th>Post Code</th>
              <th>Disposition</th>
              <th>Total Product</th>
              <th>Sale Date</th>
              <th>Center Name</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan="15" style={{ textAlign: "center" }}>
                  No records found
                </td>
              </tr>
            ) : (
              filteredData.map((row, index) => (
                <tr key={index}>
                  <td>{row.customerID}</td>
                  <td>{row.assignedQAUser}</td>
                  <td>{row.finalDisposition}</td>
                  <td>{row.leadsourceName}</td>
                  <td>{row.campaignName}</td>
                  <td>{row.firstName}</td>
                  <td>{row.lastName}</td>
                  <td>{row.address}</td>
                  <td>{row.city}</td>
                  <td>{row.state}</td>
                  <td>{row.postcode}</td>
                  <td>{row.disposition}</td>
                  <td>{row.totalProduct}</td>
                  <td>{row.saleDate}</td>
                  <td>{row.centerName}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QA;
